module.exports = __webpack_public_path__ + "images/shop/favicon-kfz24/favicon-16x16.png";